import { option } from 'fp-ts';
import { useState } from 'react';
import { Catalog, CatalogFieldDetails } from 'modules/domains/catalog';
import { OnlyChildren } from 'utils/reactHelpers';
import { CatalogContext, CatalogContextState } from './catalogContext';

export const CatalogContextProvider = ({ children }: OnlyChildren) => {
  const [catalog, change] = useState<option.Option<Catalog>>(option.none);
  const [hasCatalogError, updateCatalogErrorState] = useState<boolean>(false);
  const [hasCatalogFieldError, updateCatalogFieldErrorState] = useState<boolean>(false);
  const [catalogFieldDetails, changeFieldDetails] = useState<option.Option<CatalogFieldDetails>>(
    option.none,
  );

  const updateCatalogError = () => {
    updateCatalogErrorState(option.isNone(catalog));
  };
  const updateCatalogFieldError = () => {
    updateCatalogFieldErrorState(option.isNone(catalogFieldDetails));
  };

  const value: CatalogContextState = {
    catalog,
    change,
    catalogFieldDetails,
    changeFieldDetails,
    hasCatalogError,
    updateCatalogError,
    hasCatalogFieldError,
    updateCatalogFieldError,
  };

  return <CatalogContext.Provider value={value}>{children}</CatalogContext.Provider>;
};
